{
  "level": "q312",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:q312",
    "objects": "AREAS.E3:q312.e3",
    "mesh": "TREES.E3:q312.e3"
  },
  "spawn_point": {
    "position": [
      577.5438801883872,
      -329.8703254250919,
      24.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      577.5438801883872,
      -229.8703254250919,
      24.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -4714.04296875,
      -4547.06494140625,
      0.0
    ],
    "bbox_max": [
      7600.0,
      2270.430419921875,
      1493.904296875
    ],
    "vertex_count": 306,
    "vertices": [
      [
        -3918.229736328125,
        -1600.0,
        1251.2120361328125
      ],
      [
        -3802.89990234375,
        -1600.0,
        151.26791381835938
      ],
      [
        -3725.158447265625,
        -2329.2001953125,
        1299.8638916015625
      ],
      [
        -3605.362548828125,
        -2269.30224609375,
        2.07568359375
      ],
      [
        -3484.299560546875,
        -4107.08740234375,
        1043.779052734375
      ],
      [
        -3534.807373046875,
        -3975.598876953125,
        1396.642822265625
      ],
      [
        -3468.283203125,
        -4518.4345703125,
        1390.1170654296875
      ],
      [
        -3449.65869140625,
        -4427.673828125,
        1087.3863525390625
      ],
      [
        -4714.04296875,
        -1600.000244140625,
        1446.2291259765625
      ],
      [
        -4356.13525390625,
        -1600.0,
        1314.8355712890625
      ],
      [
        -3569.178466796875,
        -3565.310546875,
        1239.0843505859375
      ],
      [
        -3573.0205078125,
        -3584.09765625,
        1301.61328125
      ],
      [
        -3614.939453125,
        -3588.4169921875,
        1317.599365234375
      ],
      [
        -3580.16259765625,
        -3619.02294921875,
        1417.85400390625
      ],
      [
        -3697.798095703125,
        -2384.52392578125,
        1182.31201171875
      ],
      [
        -3605.362548828125,
        -2269.30224609375,
        2.075690984725952
      ],
      [
        -3400.0,
        -3997.185546875,
        1045.6182861328125
      ],
      [
        -3400.0,
        -3799.849853515625,
        1399.583984375
      ],
      [
        -3400.0,
        -3594.320556640625,
        1328.766845703125
      ],
      [
        -3400.0,
        -3618.565185546875,
        1409.2655029296875
      ],
      [
        -3400.0,
        -4547.06494140625,
        1390.1160888671875
      ],
      [
        -3400.0,
        -4452.255859375,
        1098.934814453125
      ],
      [
        -3697.798095703125,
        -2384.52392578125,
        1182.31201171875
      ],
      [
        -3702.450439453125,
        -2378.30322265625,
        1210.55859375
      ],
      [
        -3702.450439453125,
        -2378.30322265625,
        1210.55859375
      ],
      [
        -3703.801513671875,
        -2376.973876953125,
        1220.0
      ],
      [
        -3400.0,
        -2501.514404296875,
        0.0
      ],
      [
        -3400.0,
        -2699.58935546875,
        585.6629638671875
      ],
      [
        -3400.0,
        -2737.88818359375,
        716.9644165039062
      ],
      [
        -3400.0,
        -2730.576416015625,
        935.9595336914062
      ],
      [
        -3400.0,
        -2730.576416015625,
        935.9595336914062
      ],
      [
        -3400.0,
        -2739.030517578125,
        1220.0
      ],
      [
        -3400.0,
        -2737.88818359375,
        716.9644165039062
      ],
      [
        -3400.0,
        -2699.58935546875,
        585.6629638671875
      ],
      [
        -3284.755615234375,
        -3846.94091796875,
        1048.1326904296875
      ],
      [
        -3400.0,
        -3942.7783203125,
        1143.2099609375
      ],
      [
        -3382.33544921875,
        -3776.8203125,
        1399.9693603515625
      ],
      [
        3885.714111328125,
        -1600.0,
        531.17138671875
      ],
      [
        5535.333984375,
        -1600.0,
        752.4107666015625
      ],
      [
        650.0,
        -2598.9130859375,
        1493.904296875
      ],
      [
        650.0,
        -2378.125,
        1284.1875
      ],
      [
        650.0,
        -2378.125,
        1284.1875
      ],
      [
        650.0,
        -2007.71044921875,
        793.1160278320312
      ],
      [
        2400.0,
        -1600.0,
        457.1454162597656
      ],
      [
        3885.71435546875,
        -1600.0,
        531.17138671875
      ],
      [
        2400.0,
        -1600.0,
        457.14544677734375
      ],
      [
        5742.85693359375,
        -1600.0,
        780.2428588867188
      ],
      [
        7600.0,
        -1600.0,
        852.5999755859375
      ],
      [
        5742.857421875,
        -1600.0,
        780.2428588867188
      ],
      [
        -439.7000732421875,
        -1600.0,
        273.6990966796875
      ],
      [
        -439.7000732421875,
        -1600.0,
        273.6990966796875
      ],
      [
        -668.6326904296875,
        -1600.0,
        135.5116729736328
      ],
      [
        -1080.0,
        -1600.0,
        40.2599983215332
      ],
      [
        -668.6326904296875,
        -1600.0,
        135.51168823242188
      ],
      [
        -3907.636962890625,
        -1600.0,
        1150.1849365234375
      ],
      [
        4150.62451171875,
        1343.3211669921875,
        834.5104370117188
      ],
      [
        4137.6171875,
        1715.807373046875,
        911.6276245117188
      ],
      [
        4233.5224609375,
        -1030.5604248046875,
        167.20753479003906
      ],
      [
        5061.2900390625,
        -1252.3572998046875,
        431.7252502441406
      ],
      [
        4238.22021484375,
        -1165.0789794921875,
        315.1871643066406
      ],
      [
        6186.53076171875,
        -1445.1373291015625,
        575.4178466796875
      ],
      [
        5061.2900390625,
        -1252.3572998046875,
        431.7252502441406
      ],
      [
        6186.53076171875,
        -1445.1373291015625,
        575.4178466796875
      ],
      [
        6819.673828125,
        -1455.0439453125,
        677.2412109375
      ],
      [
        6819.67333984375,
        -1455.0439453125,
        677.2412109375
      ],
      [
        7600.0,
        -1535.5943603515625,
        788.1943359375
      ],
      [
        4118.24951171875,
        2270.430419921875,
        1019.3637084960938
      ],
      [
        4137.6171875,
        1715.807373046875,
        911.6276245117188
      ],
      [
        4252.54541015625,
        -1575.3094482421875,
        538.225830078125
      ],
      [
        4253.40771484375,
        -1600.0,
        580.4847412109375
      ],
      [
        4252.54541015625,
        -1575.3094482421875,
        538.225830078125
      ],
      [
        4240.1650390625,
        -1220.775634765625,
        376.45721435546875
      ],
      [
        4240.1650390625,
        -1220.775634765625,
        376.45721435546875
      ],
      [
        2794.89013671875,
        -1124.2760009765625,
        234.20880126953125
      ],
      [
        2796.32080078125,
        -1165.2431640625,
        279.2754211425781
      ],
      [
        2811.502685546875,
        -1600.0,
        477.64862060546875
      ],
      [
        2796.32080078125,
        -1165.2431640625,
        279.275390625
      ],
      [
        553.7421875,
        -1025.6197509765625,
        60.0
      ],
      [
        -265.913330078125,
        -1425.9166259765625,
        60.0
      ],
      [
        553.7422485351562,
        -1025.6197509765625,
        60.0
      ],
      [
        969.419189453125,
        -918.7313842773438,
        60.0
      ],
      [
        -603.2200927734375,
        -1472.775146484375,
        60.0
      ],
      [
        -994.748046875,
        -1600.0,
        60.0
      ],
      [
        -265.913330078125,
        -1425.9166259765625,
        60.0
      ],
      [
        -449.9393005371094,
        -1422.967529296875,
        60.0
      ],
      [
        -526.7919921875,
        -1421.7359619140625,
        60.0
      ],
      [
        -603.2200927734375,
        -1472.7752685546875,
        60.0
      ],
      [
        -526.7919311523438,
        -1421.7359619140625,
        60.0
      ],
      [
        1214.53955078125,
        720.0,
        80.0
      ],
      [
        1230.0,
        720.0,
        80.0
      ],
      [
        1230.0,
        720.0,
        78.0
      ],
      [
        1214.53955078125,
        720.0,
        78.0
      ],
      [
        650.0,
        1187.59912109375,
        520.0
      ],
      [
        650.0,
        1187.59912109375,
        550.0
      ],
      [
        650.0,
        1187.59912109375,
        160.0
      ],
      [
        650.0,
        1187.59912109375,
        520.0
      ],
      [
        878.105224609375,
        1170.0,
        100.0
      ],
      [
        895.1558227539062,
        1160.15576171875,
        119.68839263916016
      ],
      [
        780.0,
        1051.7562255859375,
        110.0
      ],
      [
        780.0,
        1051.7562255859375,
        60.0
      ],
      [
        720.0,
        720.0,
        80.0
      ],
      [
        747.2550048828125,
        720.0,
        80.0
      ],
      [
        650.0,
        750.0,
        80.0
      ],
      [
        720.0,
        720.0,
        80.0
      ],
      [
        650.0,
        720.0,
        80.0
      ],
      [
        760.0,
        720.0,
        140.0
      ],
      [
        767.5736083984375,
        720.0,
        140.0
      ],
      [
        767.5736083984375,
        720.0,
        140.0
      ],
      [
        778.2842407226562,
        720.0,
        140.0
      ],
      [
        650.0,
        750.0,
        80.0
      ],
      [
        650.0,
        750.0,
        100.0
      ],
      [
        650.0,
        750.0,
        100.0
      ],
      [
        650.0,
        750.0,
        140.0
      ],
      [
        760.0,
        720.0,
        140.0
      ],
      [
        760.0,
        720.0,
        220.0
      ],
      [
        778.2842407226562,
        720.0,
        220.0
      ],
      [
        767.9136962890625,
        720.0,
        256.9305725097656
      ],
      [
        760.0,
        720.0,
        220.0
      ],
      [
        767.9136962890625,
        720.0,
        256.9305725097656
      ],
      [
        778.2842407226562,
        720.0,
        140.0
      ],
      [
        778.2842407226562,
        720.0,
        220.0
      ],
      [
        650.0,
        750.0,
        140.0
      ],
      [
        650.0,
        750.0,
        240.0
      ],
      [
        1905.0,
        -1277.2857666015625,
        252.5999755859375
      ],
      [
        1905.0,
        -1600.0,
        399.28826904296875
      ],
      [
        1905.0,
        -1069.97802734375,
        185.95782470703125
      ],
      [
        1905.0,
        -1277.2857666015625,
        252.5999755859375
      ],
      [
        1290.0,
        -970.5567016601562,
        103.15998840332031
      ],
      [
        1290.0,
        -1435.4285888671875,
        252.5999755859375
      ],
      [
        1290.0,
        -1435.4285888671875,
        252.5999755859375
      ],
      [
        1290.0,
        -1600.0,
        327.4051513671875
      ],
      [
        1210.0,
        540.0,
        78.0
      ],
      [
        1210.0,
        540.0,
        80.0
      ],
      [
        1250.0,
        540.0,
        60.0
      ],
      [
        1250.0,
        540.0,
        220.0
      ],
      [
        1265.0,
        620.0,
        338.0
      ],
      [
        1265.0,
        620.0,
        258.0
      ],
      [
        1265.0,
        620.0,
        258.0
      ],
      [
        1265.0,
        695.0,
        258.0
      ],
      [
        1230.0,
        540.0,
        78.0
      ],
      [
        1210.0,
        540.0,
        78.0
      ],
      [
        1210.0,
        540.0,
        80.0
      ],
      [
        1230.0,
        540.0,
        80.0
      ],
      [
        650.0,
        586.1421508789062,
        80.0
      ],
      [
        650.0,
        557.8578491210938,
        80.0
      ],
      [
        650.0,
        634.1421508789062,
        80.0
      ],
      [
        650.0,
        620.0,
        60.0
      ],
      [
        650.0,
        634.1421508789062,
        80.0
      ],
      [
        650.0,
        557.8578491210938,
        78.0
      ],
      [
        650.0,
        557.8578491210938,
        80.0
      ],
      [
        650.0,
        557.8578491210938,
        78.0
      ],
      [
        650.0,
        586.1421508789062,
        78.0
      ],
      [
        687.3342895507812,
        595.192138671875,
        80.0
      ],
      [
        694.4053344726562,
        588.12109375,
        80.0
      ],
      [
        694.4053344726562,
        588.12109375,
        80.0
      ],
      [
        666.0545654296875,
        559.7703247070312,
        98.0
      ],
      [
        1210.0,
        -957.6238403320312,
        92.38954162597656
      ],
      [
        1210.0,
        -1456.0,
        252.5999755859375
      ],
      [
        1210.0,
        -1456.0,
        252.5999755859375
      ],
      [
        1210.0,
        -1600.0,
        318.05450439453125
      ],
      [
        1210.0,
        430.31414794921875,
        60.0
      ],
      [
        1210.0,
        430.31414794921875,
        150.0
      ],
      [
        1210.0,
        430.31414794921875,
        150.0
      ],
      [
        1210.0,
        430.31414794921875,
        60.0
      ],
      [
        1210.0,
        463.61309814453125,
        80.0
      ],
      [
        1210.0,
        463.61309814453125,
        78.0
      ],
      [
        1210.0,
        463.61309814453125,
        78.0
      ],
      [
        1210.0,
        463.61309814453125,
        80.0
      ],
      [
        840.0,
        -952.0106201171875,
        60.0
      ],
      [
        840.0,
        -1551.142822265625,
        252.5999755859375
      ],
      [
        840.0,
        -1551.142822265625,
        252.5999755859375
      ],
      [
        840.0,
        -1600.0,
        274.8077697753906
      ],
      [
        1192.89697265625,
        483.61309814453125,
        78.0
      ],
      [
        1190.0,
        482.547607421875,
        78.0
      ],
      [
        840.0,
        361.57794189453125,
        78.0
      ],
      [
        840.0,
        353.8180847167969,
        78.0
      ],
      [
        864.5260009765625,
        362.8387145996094,
        78.0
      ],
      [
        1190.0,
        482.547607421875,
        78.0
      ],
      [
        864.5260009765625,
        362.8387145996094,
        78.0
      ],
      [
        840.0,
        361.5782470703125,
        80.0
      ],
      [
        840.0,
        361.5782470703125,
        92.56631469726562
      ],
      [
        840.0,
        354.8835754394531,
        80.0
      ],
      [
        840.0,
        361.57794189453125,
        80.0
      ],
      [
        840.0,
        360.5737609863281,
        78.0
      ],
      [
        840.0,
        361.5782470703125,
        80.0
      ],
      [
        864.74951171875,
        362.9208984375,
        78.0
      ],
      [
        840.0,
        351.5333557128906,
        60.0
      ],
      [
        1210.0,
        469.505859375,
        80.0
      ],
      [
        1193.9359130859375,
        463.61309814453125,
        80.0
      ],
      [
        840.0,
        341.5884094238281,
        80.0
      ],
      [
        1193.9359130859375,
        463.61309814453125,
        78.0
      ],
      [
        1210.0,
        469.505859375,
        78.0
      ],
      [
        840.0,
        341.5884094238281,
        78.0
      ],
      [
        840.0,
        341.5884094238281,
        78.0
      ],
      [
        840.0,
        341.5884094238281,
        80.0
      ],
      [
        1193.9359130859375,
        463.61309814453125,
        78.0
      ],
      [
        1193.9359130859375,
        463.61309814453125,
        80.0
      ],
      [
        840.0,
        361.5782470703125,
        100.0
      ],
      [
        840.0,
        361.5782470703125,
        120.0
      ],
      [
        840.0,
        361.5782470703125,
        100.0
      ],
      [
        840.0,
        361.5782470703125,
        120.0
      ],
      [
        840.0,
        354.88360595703125,
        120.0
      ],
      [
        840.0,
        341.656982421875,
        120.0
      ],
      [
        840.0,
        301.5333557128906,
        150.0
      ],
      [
        840.0,
        301.5333557128906,
        60.0
      ],
      [
        650.0,
        -1000.8677368164062,
        60.0
      ],
      [
        650.0,
        283.51434326171875,
        150.0
      ],
      [
        650.0,
        283.51434326171875,
        60.0
      ],
      [
        660.0,
        344.507568359375,
        140.0
      ],
      [
        660.0,
        324.5968933105469,
        140.0
      ],
      [
        660.0,
        344.507568359375,
        140.0
      ],
      [
        660.0,
        460.0,
        140.0
      ],
      [
        660.0,
        471.0,
        140.0
      ],
      [
        650.0,
        471.0,
        140.0
      ],
      [
        660.0,
        343.5030822753906,
        78.0
      ],
      [
        658.9999389648438,
        344.5075988769531,
        78.0
      ],
      [
        658.9999389648438,
        343.4082336425781,
        78.0
      ],
      [
        765.0,
        353.4609680175781,
        78.0
      ],
      [
        840.0,
        360.5737609863281,
        78.0
      ],
      [
        660.0260009765625,
        343.50555419921875,
        78.0
      ],
      [
        765.0,
        353.4609680175781,
        78.0
      ],
      [
        658.9999389648438,
        344.5075988769531,
        78.0
      ],
      [
        660.0,
        354.55242919921875,
        100.0
      ],
      [
        660.0,
        374.64215087890625,
        140.0
      ],
      [
        660.0,
        354.55242919921875,
        100.0
      ],
      [
        650.0,
        480.0,
        98.0
      ],
      [
        650.0,
        460.0,
        98.0
      ],
      [
        650.0,
        460.0,
        98.0
      ],
      [
        650.0,
        460.0,
        100.0
      ],
      [
        650.0,
        343.5592041015625,
        80.0
      ],
      [
        650.0,
        342.55474853515625,
        78.0
      ],
      [
        650.0,
        324.60308837890625,
        80.0
      ],
      [
        760.0181884765625,
        334.0764465332031,
        80.0
      ],
      [
        769.9797973632812,
        335.02056884765625,
        80.0
      ],
      [
        769.9797973632812,
        335.02056884765625,
        80.0
      ],
      [
        840.0,
        341.6569519042969,
        80.0
      ],
      [
        760.0181884765625,
        334.0764465332031,
        80.0
      ],
      [
        650.0,
        324.60308837890625,
        78.0
      ],
      [
        769.9797973632812,
        335.02056884765625,
        78.0
      ],
      [
        760.0181884765625,
        334.0764465332031,
        78.0
      ],
      [
        769.9797973632812,
        335.02056884765625,
        78.0
      ],
      [
        840.0,
        341.6569519042969,
        78.0
      ],
      [
        760.0181884765625,
        334.0764465332031,
        78.0
      ],
      [
        650.0,
        324.60308837890625,
        80.0
      ],
      [
        650.0,
        324.60308837890625,
        78.0
      ],
      [
        732.0,
        310.0,
        64.00004577636719
      ],
      [
        732.0,
        300.0,
        64.00004577636719
      ],
      [
        770.0,
        310.0,
        78.0
      ],
      [
        770.0,
        310.0,
        78.0
      ],
      [
        770.0,
        310.0,
        80.0
      ],
      [
        602.2073974609375,
        540.0,
        78.0
      ],
      [
        602.2073974609375,
        540.0,
        80.0
      ],
      [
        602.2073974609375,
        540.0,
        80.0
      ],
      [
        602.2073974609375,
        560.0,
        80.0
      ],
      [
        602.2073974609375,
        732.2073974609375,
        80.0
      ],
      [
        602.2073974609375,
        586.3495483398438,
        80.0
      ],
      [
        602.2073974609375,
        560.0,
        78.0
      ],
      [
        602.2073974609375,
        540.0,
        78.0
      ],
      [
        572.8872680664062,
        736.8284301757812,
        78.0
      ],
      [
        554.5025024414062,
        755.2131958007812,
        78.0
      ],
      [
        556.4309692382812,
        753.2847290039062,
        80.0
      ],
      [
        556.4309692382812,
        753.2847290039062,
        80.0
      ],
      [
        546.4309692382812,
        743.2847290039062,
        80.0
      ],
      [
        596.2720947265625,
        579.0,
        78.0
      ],
      [
        602.2073974609375,
        586.3495483398438,
        80.0
      ],
      [
        602.2073974609375,
        584.935302734375,
        78.0
      ],
      [
        602.2073974609375,
        572.2073974609375,
        60.0
      ],
      [
        550.0,
        1209.3953857421875,
        520.0
      ],
      [
        550.0,
        1209.3953857421875,
        550.0
      ],
      [
        550.0,
        1209.3953857421875,
        160.0
      ],
      [
        550.0,
        1209.3953857421875,
        520.0
      ],
      [
        549.9862060546875,
        799.9862060546875,
        240.0
      ],
      [
        549.9862060546875,
        799.9862060546875,
        260.0
      ],
      [
        550.0,
        746.853759765625,
        80.0
      ],
      [
        550.0,
        739.7156982421875,
        81.85070037841797
      ],
      [
        602.2073974609375,
        750.0,
        100.0
      ],
      [
        602.2073974609375,
        750.0,
        140.0
      ],
      [
        602.2073974609375,
        750.0,
        140.0
      ],
      [
        602.2073974609375,
        750.0,
        240.0
      ],
      [
        559.7156982421875,
        750.0,
        81.70327758789062
      ],
      [
        553.146240234375,
        750.0,
        80.0
      ],
      [
        559.7156982421875,
        750.0,
        80.0
      ],
      [
        559.7156982421875,
        750.0,
        81.70327758789062
      ],
      [
        602.2073974609375,
        732.2073974609375,
        80.0
      ],
      [
        602.2073974609375,
        732.2073974609375,
        102.2073974609375
      ],
      [
        602.2073974609375,
        732.2073974609375,
        120.0
      ],
      [
        602.2073974609375,
        732.2073974609375,
        102.2073974609375
      ],
      [
        580.8578491210938,
        739.1421508789062,
        90.00000762939453
      ],
      [
        580.8578491210938,
        739.1421508789062,
        90.0
      ],
      [
        590.5001831054688,
        729.4998168945312,
        95.0
      ],
      [
        602.2073974609375,
        -1590.916259765625,
        242.55006408691406
      ],
      [
        602.2073974609375,
        -1600.0,
        253.5253448486328
      ],
      [
        602.2073974609375,
        -1314.816650390625,
        156.972900390625
      ],
      [
        602.2073974609375,
        -1590.916259765625,
        242.550048828125
      ],
      [
        602.2073974609375,
        -1314.81640625,
        156.97283935546875
      ],
      [
        602.2073974609375,
        -1013.1572875976562,
        60.0
      ],
      [
        639.9603271484375,
        540.0,
        80.0
      ],
      [
        639.9603271484375,
        540.0,
        78.0
      ],
      [
        630.0,
        291.6624755859375,
        60.0
      ],
      [
        630.0,
        540.0,
        80.0
      ],
      [
        630.0,
        540.0,
        78.0
      ],
      [
        630.0,
        480.0,
        98.0
      ],
      [
        630.0,
        460.0,
        98.0
      ],
      [
        630.0,
        460.0,
        98.0
      ],
      [
        630.0,
        460.0,
        100.0
      ],
      [
        602.2073974609375,
        -1594.5013427734375,
        246.88169860839844
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -4714.04296875,
        -4547.06494140625,
        0.0
      ],
      "bbox_max": [
        -3400.0,
        -1600.0,
        1446.2291259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9880585670471191,
        0.11992283910512924,
        0.09674030542373657
      ],
      "plane_d": 3834.25,
      "bbox_min": [
        -4714.04296875,
        -4547.06494140625,
        2.07568359375
      ],
      "bbox_max": [
        -3400.0,
        -1600.0,
        1446.2291259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8395622968673706,
        0.49151238799095154,
        0.231409952044487
      ],
      "plane_d": 4493.8125,
      "bbox_min": [
        -4714.04296875,
        -4518.4345703125,
        1040.098388671875
      ],
      "bbox_max": [
        -3449.65869140625,
        -1600.0,
        1446.2291259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8469141721725464,
        0.5269691348075867,
        0.07099299877882004
      ],
      "plane_d": 4842.2216796875,
      "bbox_min": [
        -4205.1796875,
        -4518.4345703125,
        1040.098388671875
      ],
      "bbox_max": [
        -3449.65869140625,
        -2619.13720703125,
        1400.2685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483099102973938,
        -0.5793927907943726,
        0.3230113983154297
      ],
      "plane_d": -109.43359375,
      "bbox_min": [
        -3833.671875,
        -4518.4345703125,
        1040.098388671875
      ],
      "bbox_max": [
        -3449.65869140625,
        -3975.598876953125,
        1396.642822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.603515625,
      "bbox_min": [
        -3833.671875,
        -4518.4345703125,
        1040.098388671875
      ],
      "bbox_max": [
        -3449.65869140625,
        -4327.0185546875,
        1390.1221923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -4714.04296875,
        -3619.13720703125,
        1220.0
      ],
      "bbox_max": [
        -3569.178466796875,
        -1600.0,
        1446.2291259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011314941570162773,
        0.9574529528617859,
        0.2883673906326294
      ],
      "plane_d": 3096.69091796875,
      "bbox_min": [
        -3614.939453125,
        -3588.4169921875,
        1220.0
      ],
      "bbox_max": [
        -3569.178466796875,
        -3559.13720703125,
        1317.599365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011314941570162773,
        0.9574529528617859,
        0.2883673906326294
      ],
      "plane_d": 3096.69091796875,
      "bbox_min": [
        -3625.179443359375,
        -3619.13720703125,
        1301.61328125
      ],
      "bbox_max": [
        -3573.0205078125,
        -3584.09765625,
        1420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8705313205718994,
        0.4785127639770508,
        0.11489474773406982
      ],
      "plane_d": 4224.23291015625,
      "bbox_min": [
        -3712.849365234375,
        -4547.06494140625,
        2.075690984725952
      ],
      "bbox_max": [
        -3400.0,
        -2269.30224609375,
        1417.85400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483099102973938,
        -0.5793927907943726,
        0.3230113983154297
      ],
      "plane_d": -109.43359375,
      "bbox_min": [
        -3580.16259765625,
        -4547.06494140625,
        1043.779052734375
      ],
      "bbox_max": [
        -3400.0,
        -3565.310546875,
        1417.85400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011314941570162773,
        0.9574529528617859,
        0.2883673906326294
      ],
      "plane_d": 3096.69091796875,
      "bbox_min": [
        -3580.16259765625,
        -3619.02294921875,
        1239.0843505859375
      ],
      "bbox_max": [
        -3400.0,
        -3565.310546875,
        1417.85400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.603515625,
      "bbox_min": [
        -3468.283203125,
        -4547.06494140625,
        1087.3863525390625
      ],
      "bbox_max": [
        -3400.0,
        -4427.673828125,
        1390.1170654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7499687671661377,
        0.6611047983169556,
        -0.022072862833738327
      ],
      "plane_d": 4375.75,
      "bbox_min": [
        -3712.849365234375,
        -2384.52392578125,
        1182.31201171875
      ],
      "bbox_max": [
        -3697.798095703125,
        -2366.191162109375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3712.849365234375,
        -2378.30322265625,
        1210.55859375
      ],
      "bbox_max": [
        -3702.450439453125,
        -2366.191162109375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9880585670471191,
        0.11992283910512924,
        0.09674030542373657
      ],
      "plane_d": 3834.25,
      "bbox_min": [
        -3725.179443359375,
        -2739.030517578125,
        0.0
      ],
      "bbox_max": [
        -3400.0,
        -2269.13720703125,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8705313205718994,
        0.4785127639770508,
        0.11489474773406982
      ],
      "plane_d": 4224.23291015625,
      "bbox_min": [
        -3703.801513671875,
        -2739.030517578125,
        0.0
      ],
      "bbox_max": [
        -3400.0,
        -2269.13720703125,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7315089106559753,
        0.6458920836448669,
        0.21844476461410522
      ],
      "plane_d": 4102.8388671875,
      "bbox_min": [
        -3703.801513671875,
        -2739.030517578125,
        0.0
      ],
      "bbox_max": [
        -3400.0,
        -2269.13720703125,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7499687671661377,
        0.6611047983169556,
        -0.022072862833738327
      ],
      "plane_d": 4375.75,
      "bbox_min": [
        -3703.801513671875,
        -2739.030517578125,
        585.6629638671875
      ],
      "bbox_max": [
        -3400.0,
        -2376.973876953125,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3703.801513671875,
        -2739.030517578125,
        935.9595336914062
      ],
      "bbox_max": [
        -3400.0,
        -2376.973876953125,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7204001545906067,
        0.6658127903938293,
        0.19420865178108215
      ],
      "plane_d": 4133.041015625,
      "bbox_min": [
        -3505.179443359375,
        -2737.88818359375,
        585.6629638671875
      ],
      "bbox_max": [
        -3400.0,
        -2619.13720703125,
        716.9644165039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4769039750099182,
        0.7969357371330261,
        0.37075066566467285
      ],
      "plane_d": 1317.8310546875,
      "bbox_min": [
        -3400.0,
        -5072.0185546875,
        0.0
      ],
      "bbox_max": [
        -1550.0,
        -2501.514404296875,
        1652.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.603515625,
      "bbox_min": [
        -3400.0,
        -5072.0185546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -1550.0,
        -3350.0,
        1652.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5160083770751953,
        0.7518967390060425,
        0.41034960746765137
      ],
      "plane_d": 1040.8973388671875,
      "bbox_min": [
        -2100.0,
        -3623.86962890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -1550.0,
        -3350.0,
        1652.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3156070411205292,
        0.8320549726486206,
        0.45615431666374207
      ],
      "plane_d": 1686.0640869140625,
      "bbox_min": [
        -3400.0,
        -3997.185546875,
        0.0
      ],
      "bbox_max": [
        -1701.24462890625,
        -2501.514404296875,
        1409.2655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483099102973938,
        -0.5793927907943726,
        0.3230113983154297
      ],
      "plane_d": -109.43359375,
      "bbox_min": [
        -3400.0,
        -3997.185546875,
        1045.6182861328125
      ],
      "bbox_max": [
        -3284.755615234375,
        -3846.94091796875,
        1143.2099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16772790253162384,
        0.9131852984428406,
        0.3714297413825989
      ],
      "plane_d": 2361.634521484375,
      "bbox_min": [
        -3400.0,
        -3942.7783203125,
        0.0
      ],
      "bbox_max": [
        -2100.0,
        -2501.514404296875,
        1409.2655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483099102973938,
        -0.5793927907943726,
        0.3230113983154297
      ],
      "plane_d": -109.43359375,
      "bbox_min": [
        -3400.0,
        -3942.7783203125,
        1048.1326904296875
      ],
      "bbox_max": [
        -3080.0,
        -3580.0,
        1399.9693603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965404748916626,
        -0.2439502775669098,
        0.09209758043289185
      ],
      "plane_d": 2003.16259765625,
      "bbox_min": [
        -3400.0,
        -3776.8203125,
        0.0
      ],
      "bbox_max": [
        -2861.24462890625,
        -2501.514404296875,
        1409.2655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6317505836486816,
        0.763104259967804,
        0.13624615967273712
      ],
      "plane_d": 4182.1328125,
      "bbox_min": [
        -3400.0,
        -3776.8203125,
        0.0
      ],
      "bbox_max": [
        -2861.24462890625,
        -2501.514404296875,
        1409.2655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8451709151268005,
        -0.3576369881629944,
        0.3972178101539612
      ],
      "plane_d": 904.6746826171875,
      "bbox_min": [
        -3400.0,
        -3776.8203125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3003.01416015625,
        -3212.1396484375,
        1409.2655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483099102973938,
        -0.5793927907943726,
        0.3230113983154297
      ],
      "plane_d": -109.43359375,
      "bbox_min": [
        -3400.0,
        -3776.8203125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3080.0,
        -3580.0,
        1409.2655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011314941570162773,
        0.9574529528617859,
        0.2883673906326294
      ],
      "plane_d": 3096.69091796875,
      "bbox_min": [
        -3400.0,
        -3618.565185546875,
        1328.766845703125
      ],
      "bbox_max": [
        -3260.67529296875,
        -3594.320556640625,
        1409.2655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7315089106559753,
        0.6458920836448669,
        0.21844476461410522
      ],
      "plane_d": 4102.8388671875,
      "bbox_min": [
        -3400.0,
        -3212.1396484375,
        0.0
      ],
      "bbox_max": [
        -2861.24462890625,
        -2501.514404296875,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7204001545906067,
        0.6658127903938293,
        0.19420865178108215
      ],
      "plane_d": 4133.041015625,
      "bbox_min": [
        -3400.0,
        -3212.1396484375,
        0.0
      ],
      "bbox_max": [
        -2861.24462890625,
        -2699.58935546875,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3400.0,
        -3212.1396484375,
        716.9644165039062
      ],
      "bbox_max": [
        -3003.01416015625,
        -2730.576416015625,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7499687671661377,
        0.6611047983169556,
        -0.022072862833738327
      ],
      "plane_d": 4375.75,
      "bbox_min": [
        -3400.0,
        -2969.13720703125,
        716.9644165039062
      ],
      "bbox_max": [
        -3195.179443359375,
        -2730.576416015625,
        935.9595336914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04072042927145958,
        0.6873272061347961,
        0.7252056002616882
      ],
      "plane_d": 709.023681640625,
      "bbox_min": [
        650.0,
        -2850.0,
        252.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1600.0,
        2100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.027883131057024002,
        0.7254633903503418,
        0.6876956224441528
      ],
      "plane_d": 797.6543579101562,
      "bbox_min": [
        650.0,
        -2850.0,
        252.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1600.0,
        2100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        650.0,
        -2850.0,
        252.5999755859375
      ],
      "bbox_max": [
        5535.333984375,
        -1600.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        650.0,
        -2850.0,
        793.1160278320312
      ],
      "bbox_max": [
        2400.0,
        -2007.71044921875,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        650.0,
        -2378.125,
        793.1160278320312
      ],
      "bbox_max": [
        2400.0,
        -2007.71044921875,
        1284.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        650.0,
        -2050.0,
        252.5999755859375
      ],
      "bbox_max": [
        3885.71435546875,
        -1600.0,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.47637939453125,
      "bbox_min": [
        650.0,
        -1700.0,
        252.5999755859375
      ],
      "bbox_max": [
        3885.71435546875,
        -1600.0,
        531.17138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.4123840332031,
      "bbox_min": [
        2400.0,
        -1700.0,
        457.14544677734375
      ],
      "bbox_max": [
        3885.71435546875,
        -1600.0,
        531.17138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.02753951959311962,
        0.7068385481834412,
        0.7068385481834412
      ],
      "plane_d": 737.5914916992188,
      "bbox_min": [
        2400.0,
        -2050.0,
        752.4107666015625
      ],
      "bbox_max": [
        7600.0,
        -1600.0,
        1152.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        2400.0,
        -2050.0,
        752.4107666015625
      ],
      "bbox_max": [
        5742.857421875,
        -1600.0,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -1201.24462890625,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        650.0,
        -1600.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -825.0,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        400.0,
        -2275.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -1080.0,
        -2598.9130859375,
        40.2599983215332
      ],
      "bbox_max": [
        650.0,
        -1600.0,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18530525267124176,
        0.5702676773071289,
        0.8002853393554688
      ],
      "plane_d": 680.0791625976562,
      "bbox_min": [
        -1080.0,
        -2050.0,
        40.2599983215332
      ],
      "bbox_max": [
        -668.6326904296875,
        -1600.0,
        402.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        0.0,
        -2598.9130859375,
        252.5999755859375
      ],
      "bbox_max": [
        650.0,
        -1600.0,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        0.0,
        -2598.9130859375,
        1284.1875
      ],
      "bbox_max": [
        650.0,
        -2378.125,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -6971.595703125,
        -1600.000244140625,
        151.26791381835938
      ],
      "bbox_max": [
        -3802.89990234375,
        2921.382080078125,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -4912.15185546875,
        -1600.0,
        151.26791381835938
      ],
      "bbox_max": [
        -3802.89990234375,
        2154.178466796875,
        1150.1849365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -4912.15185546875,
        -1600.0,
        1000.0
      ],
      "bbox_max": [
        -3907.636962890625,
        2154.178466796875,
        1251.2120361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1585269570350647,
        -0.2054760754108429,
        0.9657374024391174
      ],
      "plane_d": 128.0882568359375,
      "bbox_min": [
        4118.24951171875,
        -1600.0,
        0.0
      ],
      "bbox_max": [
        7986.5068359375,
        3895.50634765625,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01684202253818512,
        0.7395898699760437,
        0.6728469729423523
      ],
      "plane_d": 720.988037109375,
      "bbox_min": [
        4118.24951171875,
        -1535.5943603515625,
        0.0
      ],
      "bbox_max": [
        7823.75537109375,
        2280.14306640625,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        6186.53076171875,
        -1535.5943603515625,
        575.4178466796875
      ],
      "bbox_max": [
        7600.0,
        -1350.0,
        788.1943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.02753951959311962,
        0.7068385481834412,
        0.7068385481834412
      ],
      "plane_d": 737.5914916992188,
      "bbox_min": [
        6819.67333984375,
        -1535.5943603515625,
        602.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1350.0,
        788.1943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46037399768829346,
        -0.18474237620830536,
        0.8682891130447388
      ],
      "plane_d": 1430.2772216796875,
      "bbox_min": [
        4118.24951171875,
        1715.807373046875,
        911.6276245117188
      ],
      "bbox_max": [
        4137.6171875,
        2280.14306640625,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1491488516330719,
        -0.38985106348991394,
        0.9087193608283997
      ],
      "plane_d": 568.5120849609375,
      "bbox_min": [
        4137.6171875,
        -1600.0,
        315.1871643066406
      ],
      "bbox_max": [
        7986.5068359375,
        3895.50634765625,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        4238.22021484375,
        -1600.0,
        315.1871643066406
      ],
      "bbox_max": [
        7600.0,
        -1165.0789794921875,
        852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.02753951959311962,
        0.7068385481834412,
        0.7068385481834412
      ],
      "plane_d": 737.5914916992188,
      "bbox_min": [
        5742.85693359375,
        -1600.0,
        677.2412109375
      ],
      "bbox_max": [
        7600.0,
        -1455.0439453125,
        852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.4123840332031,
      "bbox_min": [
        4238.22021484375,
        -1575.3094482421875,
        315.1871643066406
      ],
      "bbox_max": [
        6186.53076171875,
        -1165.0789794921875,
        575.4178466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01684202253818512,
        0.7395898699760437,
        0.6728469729423523
      ],
      "plane_d": 720.988037109375,
      "bbox_min": [
        4238.22021484375,
        -1252.3572998046875,
        315.1871643066406
      ],
      "bbox_max": [
        5061.2900390625,
        -1165.0789794921875,
        431.7252502441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01684202253818512,
        0.7395898699760437,
        0.6728469729423523
      ],
      "plane_d": 720.988037109375,
      "bbox_min": [
        2794.89013671875,
        -1600.0,
        167.20753479003906
      ],
      "bbox_max": [
        4253.40771484375,
        2270.430419921875,
        1019.3637084960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.4123840332031,
      "bbox_min": [
        2796.32080078125,
        -1600.0,
        279.275390625
      ],
      "bbox_max": [
        4253.40771484375,
        -1165.2431640625,
        580.4847412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        3885.714111328125,
        -1600.0,
        531.17138671875
      ],
      "bbox_max": [
        4253.40771484375,
        -1575.3094482421875,
        580.4847412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46037399768829346,
        -0.18474237620830536,
        0.8682891130447388
      ],
      "plane_d": 1430.2772216796875,
      "bbox_min": [
        3240.0,
        1340.1431884765625,
        460.0
      ],
      "bbox_max": [
        4150.62451171875,
        2270.430419921875,
        1019.3637084960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1585269570350647,
        -0.2054760754108429,
        0.9657374024391174
      ],
      "plane_d": 128.0882568359375,
      "bbox_min": [
        4137.6171875,
        1340.1431884765625,
        831.6990966796875
      ],
      "bbox_max": [
        4150.62451171875,
        1715.807373046875,
        911.6276245117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3825902044773102,
        0.0,
        0.9239181876182556
      ],
      "plane_d": 814.5899047851562,
      "bbox_min": [
        3240.0,
        1340.1431884765625,
        460.0
      ],
      "bbox_max": [
        4137.6171875,
        1830.0,
        831.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        -1280.0,
        -1600.0,
        0.0
      ],
      "bbox_max": [
        2811.502685546875,
        2220.0,
        1600.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.14309725165367126,
        0.2930086553096771,
        0.9453407526016235
      ],
      "plane_d": 323.03399658203125,
      "bbox_min": [
        -1100.0,
        -1600.0,
        0.0
      ],
      "bbox_max": [
        969.419189453125,
        -846.68505859375,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        523.75537109375,
        -1025.6197509765625,
        0.0
      ],
      "bbox_max": [
        969.419189453125,
        -846.68505859375,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18530525267124176,
        0.5702676773071289,
        0.8002853393554688
      ],
      "plane_d": 680.0791625976562,
      "bbox_min": [
        -1100.0,
        -1600.0,
        0.0
      ],
      "bbox_max": [
        -265.913330078125,
        -1371.68505859375,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -551.24462890625,
        -1425.9166259765625,
        0.0
      ],
      "bbox_max": [
        -265.913330078125,
        -1371.68505859375,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -603.2200927734375,
        -1472.7752685546875,
        0.0
      ],
      "bbox_max": [
        -449.9393005371094,
        -1371.68505859375,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -551.24462890625,
        -1422.967529296875,
        0.0
      ],
      "bbox_max": [
        -449.9393005371094,
        -1371.68505859375,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        -994.748046875,
        -1600.0,
        60.0
      ],
      "bbox_max": [
        2811.502685546875,
        1579.9000244140625,
        1600.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        650.0,
        -1600.0,
        60.0
      ],
      "bbox_max": [
        2811.502685546875,
        1579.9000244140625,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1910.0,
        1470.0,
        500.0
      ],
      "bbox_max": [
        2091.7158203125,
        1579.9000244140625,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1910.0,
        1470.0,
        500.0
      ],
      "bbox_max": [
        1910.0,
        1579.9000244140625,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        1214.53955078125,
        720.0,
        78.0
      ],
      "bbox_max": [
        1769.9998779296875,
        1508.2841796875,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2162.533447265625,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        500.0
      ],
      "bbox_max": [
        1588.2841796875,
        1508.2841796875,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        1214.53955078125,
        720.0,
        78.0
      ],
      "bbox_max": [
        1230.0,
        727.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        1214.53955078125,
        720.0,
        78.0
      ],
      "bbox_max": [
        1230.0,
        727.730224609375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        650.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1008.2842407226562,
        1285.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 578.7291259765625,
      "bbox_min": [
        650.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        905.0,
        1285.0,
        600.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9510565400123596,
        -0.30901700258255005,
        0.0
      ],
      "plane_d": -287.18438720703125,
      "bbox_min": [
        699.5303955078125,
        1223.5849609375,
        160.0
      ],
      "bbox_max": [
        719.4853515625,
        1285.0,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9112825989723206,
        -0.4117816090583801,
        -0.0
      ],
      "plane_d": 1143.894287109375,
      "bbox_min": [
        760.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        905.0,
        1212.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000002384185791,
        -0.8660252690315247,
        -0.0
      ],
      "plane_d": 1452.3023681640625,
      "bbox_min": [
        760.0,
        1006.109130859375,
        60.0
      ],
      "bbox_max": [
        905.0,
        1212.0,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000002384185791,
        -0.8660252690315247,
        0.0
      ],
      "plane_d": 612.3018798828125,
      "bbox_min": [
        840.0,
        1160.15576171875,
        100.0
      ],
      "bbox_max": [
        905.0,
        1212.0,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": 1091.201171875,
      "bbox_min": [
        878.105224609375,
        1160.15576171875,
        100.0
      ],
      "bbox_max": [
        905.0,
        1170.0,
        119.68839263916016
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": 1091.201171875,
      "bbox_min": [
        760.0,
        1006.109130859375,
        60.0
      ],
      "bbox_max": [
        895.1558227539062,
        1170.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1006.109130859375,
        60.0
      ],
      "bbox_max": [
        822.5736083984375,
        1120.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112828373908997,
        -0.4117811918258667,
        0.0
      ],
      "plane_d": 1163.89404296875,
      "bbox_min": [
        805.0,
        1006.109130859375,
        110.0
      ],
      "bbox_max": [
        822.5736083984375,
        1045.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        780.0,
        1051.7562255859375,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        650.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1008.2842407226562,
        950.0,
        570.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        750.0,
        60.0
      ],
      "bbox_max": [
        780.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        650.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1008.2842407226562,
        950.0,
        570.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        650.0,
        750.0,
        80.0
      ],
      "bbox_max": [
        780.0,
        930.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        650.0,
        750.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        750.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        650.0,
        720.0,
        140.0
      ],
      "bbox_max": [
        1008.2842407226562,
        950.0,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693566083908081,
        -0.693566083908081,
        0.19476176798343658
      ],
      "plane_d": -83.2716064453125,
      "bbox_min": [
        760.0,
        720.0,
        140.0
      ],
      "bbox_max": [
        1008.2842407226562,
        950.0,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9778023958206177,
        0.0,
        0.2095290869474411
      ],
      "plane_d": 697.033447265625,
      "bbox_min": [
        760.0,
        720.0,
        140.0
      ],
      "bbox_max": [
        1008.2842407226562,
        950.0,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        778.2842407226562,
        720.0,
        140.0
      ],
      "bbox_max": [
        1008.2842407226562,
        950.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        650.0,
        750.0,
        140.0
      ],
      "bbox_max": [
        720.0,
        750.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.47637939453125,
      "bbox_min": [
        1905.0,
        -1600.0,
        185.95782470703125
      ],
      "bbox_max": [
        2811.502685546875,
        -1069.97802734375,
        477.64862060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.4123840332031,
      "bbox_min": [
        2400.0,
        -1600.0,
        234.20880126953125
      ],
      "bbox_max": [
        2811.502685546875,
        -1124.2760009765625,
        477.64862060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01684202253818512,
        0.7395898699760437,
        0.6728469729423523
      ],
      "plane_d": 720.988037109375,
      "bbox_min": [
        2400.0,
        -1165.2431640625,
        234.20880126953125
      ],
      "bbox_max": [
        2796.32080078125,
        -1124.2760009765625,
        279.2754211425781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        1905.0,
        -1277.2857666015625,
        185.95782470703125
      ],
      "bbox_max": [
        2400.0,
        -1069.97802734375,
        252.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        1290.0,
        -1600.0,
        103.15998840332031
      ],
      "bbox_max": [
        1905.0,
        620.0,
        399.28826904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.47637939453125,
      "bbox_min": [
        1290.0,
        -1600.0,
        252.5999755859375
      ],
      "bbox_max": [
        1905.0,
        620.0,
        399.28826904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6305926442146301,
        -0.7761140465736389,
        -0.0
      ],
      "plane_d": 1294.6552734375,
      "bbox_min": [
        1290.0,
        538.75,
        258.0
      ],
      "bbox_max": [
        1390.0,
        620.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1210.0,
      "bbox_min": [
        650.0,
        540.0,
        60.0
      ],
      "bbox_max": [
        1290.0,
        720.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1210.0,
        540.0,
        60.0
      ],
      "bbox_max": [
        1290.0,
        720.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1265.0,
      "bbox_min": [
        1260.0,
        620.0,
        60.0
      ],
      "bbox_max": [
        1290.0,
        720.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 620.0,
      "bbox_min": [
        1265.0,
        620.0,
        60.0
      ],
      "bbox_max": [
        1290.0,
        695.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 258.0,
      "bbox_min": [
        1265.0,
        620.0,
        258.0
      ],
      "bbox_max": [
        1290.0,
        695.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1260.0,
      "bbox_min": [
        1260.0,
        620.0,
        220.0
      ],
      "bbox_max": [
        1265.0,
        700.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 620.0,
      "bbox_min": [
        1260.0,
        620.0,
        258.0
      ],
      "bbox_max": [
        1265.0,
        700.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 258.0,
      "bbox_min": [
        1260.0,
        620.0,
        258.0
      ],
      "bbox_max": [
        1265.0,
        700.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        1210.0,
        540.0,
        78.0
      ],
      "bbox_max": [
        1230.0,
        720.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        1210.0,
        540.0,
        80.0
      ],
      "bbox_max": [
        1230.0,
        720.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        650.0,
        540.836669921875,
        60.0
      ],
      "bbox_max": [
        778.2842407226562,
        720.0,
        256.9305725097656
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6324553489685059,
        -0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": -45.806488037109375,
      "bbox_min": [
        650.0,
        557.8578491210938,
        60.0
      ],
      "bbox_max": [
        730.0,
        704.1421508789062,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -65.15435791015625,
      "bbox_min": [
        650.0,
        557.8578491210938,
        78.0
      ],
      "bbox_max": [
        696.76953125,
        649.133544921875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        650.0,
        557.8578491210938,
        78.0
      ],
      "bbox_max": [
        689.698486328125,
        649.133544921875,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 910.2266845703125,
      "bbox_min": [
        651.5563354492188,
        611.698486328125,
        78.0
      ],
      "bbox_max": [
        675.5563354492188,
        635.698486328125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3629886209964752,
        -0.3629886209964752,
        -0.8581832647323608
      ],
      "plane_d": 534.1971435546875,
      "bbox_min": [
        687.3342895507812,
        588.12109375,
        78.0
      ],
      "bbox_max": [
        696.76953125,
        597.5563354492188,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -75.154296875,
      "bbox_min": [
        694.4053344726562,
        588.12109375,
        78.0
      ],
      "bbox_max": [
        696.76953125,
        590.4852905273438,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        658.9852905273438,
        540.836669921875,
        80.0
      ],
      "bbox_max": [
        778.2842407226562,
        720.0,
        256.9305725097656
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7072827219963074,
        -0.7069308161735535,
        0.0
      ],
      "plane_d": 866.8078002929688,
      "bbox_min": [
        658.9852905273438,
        540.836669921875,
        80.0
      ],
      "bbox_max": [
        696.76953125,
        595.192138671875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -75.154296875,
      "bbox_min": [
        658.9852905273438,
        540.836669921875,
        80.0
      ],
      "bbox_max": [
        696.76953125,
        595.192138671875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        658.9852905273438,
        559.7703247070312,
        98.0
      ],
      "bbox_max": [
        673.1273803710938,
        573.9141845703125,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        666.0545654296875,
        540.836669921875,
        98.0
      ],
      "bbox_max": [
        684.9788208007812,
        566.8431396484375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        760.0,
        701.7157592773438,
        140.0
      ],
      "bbox_max": [
        778.2842407226562,
        720.0,
        256.9305725097656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        760.0,
        701.7157592773438,
        140.0
      ],
      "bbox_max": [
        778.2842407226562,
        720.0,
        256.9305725097656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693566083908081,
        -0.693566083908081,
        0.19476176798343658
      ],
      "plane_d": -83.2716064453125,
      "bbox_min": [
        760.0,
        701.7157592773438,
        220.0
      ],
      "bbox_max": [
        778.2842407226562,
        720.0,
        256.9305725097656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9778023958206177,
        0.0,
        0.2095290869474411
      ],
      "plane_d": 697.033447265625,
      "bbox_min": [
        760.0,
        701.7157592773438,
        220.0
      ],
      "bbox_max": [
        767.9136962890625,
        720.0,
        256.9305725097656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        650.0,
        -1600.0,
        60.0
      ],
      "bbox_max": [
        1290.0,
        540.0,
        327.4051513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1210.0,
      "bbox_min": [
        840.0,
        -1600.0,
        60.0
      ],
      "bbox_max": [
        1290.0,
        540.0,
        327.4051513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        1210.0,
        -1600.0,
        60.0
      ],
      "bbox_max": [
        1290.0,
        540.0,
        327.4051513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.47637939453125,
      "bbox_min": [
        1210.0,
        -1600.0,
        60.0
      ],
      "bbox_max": [
        1290.0,
        540.0,
        327.4051513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1210.0,
        430.31414794921875,
        60.0
      ],
      "bbox_max": [
        1250.0,
        540.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3451913595199585,
        -0.9385324120521545,
        0.0
      ],
      "plane_d": -13.8177490234375,
      "bbox_min": [
        1210.0,
        430.31414794921875,
        60.0
      ],
      "bbox_max": [
        1250.0,
        540.0,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        1210.0,
        463.61309814453125,
        78.0
      ],
      "bbox_max": [
        1230.0,
        540.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 463.61309814453125,
      "bbox_min": [
        1210.0,
        463.61309814453125,
        78.0
      ],
      "bbox_max": [
        1230.0,
        463.61309814453125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        840.0,
        -1600.0,
        60.0
      ],
      "bbox_max": [
        1210.0,
        483.6131286621094,
        318.05450439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3451910614967346,
        0.9385325312614441,
        0.0
      ],
      "plane_d": 13.817352294921875,
      "bbox_min": [
        840.0,
        301.5333557128906,
        60.0
      ],
      "bbox_max": [
        1210.0,
        483.6131286621094,
        220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.3443901240825653,
        -0.9388266801834106,
        0.0
      ],
      "plane_d": 24.072601318359375,
      "bbox_min": [
        840.0,
        301.5333557128906,
        60.0
      ],
      "bbox_max": [
        1210.0,
        483.6131286621094,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3087482154369354,
        -0.8394488096237183,
        0.44721388816833496
      ],
      "plane_d": 2.780975341796875,
      "bbox_min": [
        840.0,
        341.5884094238281,
        60.0
      ],
      "bbox_max": [
        1210.0,
        483.6131286621094,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        840.0,
        351.5333557128906,
        60.0
      ],
      "bbox_max": [
        1192.89697265625,
        483.61309814453125,
        92.56631469726562
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        840.0,
        354.8835754394531,
        78.0
      ],
      "bbox_max": [
        864.74951171875,
        363.9042053222656,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08444584906101227,
        -0.8904321193695068,
        0.4472131133079529
      ],
      "plane_d": 215.24929809570312,
      "bbox_min": [
        840.0,
        360.5737609863281,
        78.0
      ],
      "bbox_max": [
        864.74951171875,
        363.9042053222656,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08444584906101227,
        -0.8904321193695068,
        0.4472131133079529
      ],
      "plane_d": 215.24929809570312,
      "bbox_min": [
        840.0,
        351.5333557128906,
        60.0
      ],
      "bbox_max": [
        866.760986328125,
        362.9208984375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        840.0,
        341.5884094238281,
        78.0
      ],
      "bbox_max": [
        1210.0,
        483.6131286621094,
        220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        840.0,
        341.5884094238281,
        78.0
      ],
      "bbox_max": [
        1210.0,
        483.61309814453125,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.09395918250083923,
        -0.9955761432647705,
        0.0
      ],
      "plane_d": 261.15155029296875,
      "bbox_min": [
        840.0,
        341.5884094238281,
        78.0
      ],
      "bbox_max": [
        864.5260009765625,
        343.9031066894531,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 463.61309814453125,
      "bbox_min": [
        1190.0,
        463.61309814453125,
        78.0
      ],
      "bbox_max": [
        1193.9359130859375,
        463.61309814453125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34519103169441223,
        -0.9385324716567993,
        0.0
      ],
      "plane_d": 43.10931396484375,
      "bbox_min": [
        840.0,
        341.656982421875,
        80.0
      ],
      "bbox_max": [
        1190.0,
        483.6131286621094,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0944133996963501,
        -0.9955331087112427,
        0.0
      ],
      "plane_d": 280.6558532714844,
      "bbox_min": [
        840.0,
        354.88360595703125,
        80.0
      ],
      "bbox_max": [
        864.5260009765625,
        363.9042053222656,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        840.0,
        354.88360595703125,
        120.0
      ],
      "bbox_max": [
        864.5260009765625,
        363.9042053222656,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        840.0,
        341.656982421875,
        120.0
      ],
      "bbox_max": [
        1190.0,
        483.6131286621094,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.09435504674911499,
        -0.9955387115478516,
        0.0
      ],
      "plane_d": 260.87451171875,
      "bbox_min": [
        840.0,
        341.656982421875,
        120.0
      ],
      "bbox_max": [
        868.9588623046875,
        344.4016418457031,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09441325813531876,
        0.9955331087112427,
        0.0
      ],
      "plane_d": -220.8793182373047,
      "bbox_min": [
        840.0,
        301.5333557128906,
        60.0
      ],
      "bbox_max": [
        1210.0,
        469.505859375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        1193.9359130859375,
        463.61309814453125,
        78.0
      ],
      "bbox_max": [
        1210.0,
        469.505859375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        1193.9359130859375,
        463.61309814453125,
        78.0
      ],
      "bbox_max": [
        1210.0,
        469.505859375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 463.61309814453125,
      "bbox_min": [
        1193.9359130859375,
        463.61309814453125,
        78.0
      ],
      "bbox_max": [
        1210.0,
        463.61309814453125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        650.0,
        -1600.0,
        60.0
      ],
      "bbox_max": [
        840.0,
        520.0,
        274.8077697753906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.47637939453125,
      "bbox_min": [
        650.0,
        -1600.0,
        252.5999755859375
      ],
      "bbox_max": [
        840.0,
        -1551.142822265625,
        274.8077697753906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09435542672872543,
        -0.995538592338562,
        0.0
      ],
      "plane_d": 260.8741455078125,
      "bbox_min": [
        650.0,
        300.0,
        60.0
      ],
      "bbox_max": [
        840.0,
        520.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        650.0,
        324.5968933105469,
        60.0
      ],
      "bbox_max": [
        840.0,
        520.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        650.0,
        324.5968933105469,
        140.0
      ],
      "bbox_max": [
        660.0,
        516.0,
        190.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 471.0,
      "bbox_min": [
        650.0,
        471.0,
        140.0
      ],
      "bbox_max": [
        660.0,
        471.0,
        143.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08444584906101227,
        -0.8904321193695068,
        0.4472131133079529
      ],
      "plane_d": 215.24929809570312,
      "bbox_min": [
        650.0,
        324.5968933105469,
        60.0
      ],
      "bbox_max": [
        840.0,
        520.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 554.5448608398438,
      "bbox_min": [
        650.0,
        333.51434326171875,
        60.0
      ],
      "bbox_max": [
        840.0,
        520.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        658.9999389648438,
        343.4082336425781,
        78.0
      ],
      "bbox_max": [
        840.0,
        361.57794189453125,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -344.5075988769531,
      "bbox_min": [
        658.9999389648438,
        344.507568359375,
        78.0
      ],
      "bbox_max": [
        660.0,
        344.5075988769531,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        650.0,
        342.55474853515625,
        78.0
      ],
      "bbox_max": [
        660.0,
        515.8578491210938,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 471.0,
      "bbox_min": [
        650.0,
        471.0,
        139.0
      ],
      "bbox_max": [
        660.0,
        471.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 460.0,
      "bbox_min": [
        650.0,
        460.0,
        98.0
      ],
      "bbox_max": [
        660.0,
        460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        650.0,
        342.55474853515625,
        78.0
      ],
      "bbox_max": [
        660.0,
        344.5075988769531,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -344.5075988769531,
      "bbox_min": [
        650.0,
        342.55474853515625,
        78.0
      ],
      "bbox_max": [
        660.0,
        344.5075988769531,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        650.0,
        342.55474853515625,
        78.0
      ],
      "bbox_max": [
        658.9999389648438,
        344.5075988769531,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0944133996963501,
        -0.9955331087112427,
        0.0
      ],
      "plane_d": 280.6558532714844,
      "bbox_min": [
        650.0,
        324.5968933105469,
        78.0
      ],
      "bbox_max": [
        840.0,
        374.64215087890625,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        660.0,
        344.507568359375,
        80.0
      ],
      "bbox_max": [
        660.0,
        374.64215087890625,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        650.0,
        324.5968933105469,
        78.0
      ],
      "bbox_max": [
        840.0,
        361.5782470703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        660.0,
        324.5968933105469,
        120.0
      ],
      "bbox_max": [
        660.0,
        344.507568359375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        650.0,
        324.60308837890625,
        78.0
      ],
      "bbox_max": [
        840.0,
        361.57794189453125,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        650.0,
        324.60308837890625,
        78.0
      ],
      "bbox_max": [
        840.0,
        360.5737609863281,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 324.60308837890625,
      "bbox_min": [
        650.0,
        324.60308837890625,
        78.0
      ],
      "bbox_max": [
        660.0,
        324.60308837890625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        660.0260009765625,
        300.0,
        60.0
      ],
      "bbox_max": [
        840.0,
        341.6569519042969,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        660.0260009765625,
        324.6031188964844,
        78.0
      ],
      "bbox_max": [
        840.0,
        341.6569519042969,
        78.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 268.32818603515625,
      "bbox_min": [
        720.0,
        300.0,
        60.0
      ],
      "bbox_max": [
        770.0,
        334.9820556640625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 299.9999694824219,
      "bbox_min": [
        720.0,
        300.0,
        60.0
      ],
      "bbox_max": [
        770.0,
        334.9820556640625,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -309.9999694824219,
      "bbox_min": [
        720.0,
        300.0,
        60.0
      ],
      "bbox_max": [
        770.0,
        334.9820556640625,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -270.11700439453125,
      "bbox_min": [
        724.0,
        300.0,
        60.0
      ],
      "bbox_max": [
        770.0,
        310.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        732.0,
        300.0,
        64.00004577636719
      ],
      "bbox_max": [
        732.0,
        310.0,
        66.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        732.0,
        300.0,
        60.0
      ],
      "bbox_max": [
        770.0,
        310.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        770.0,
        300.0,
        78.0
      ],
      "bbox_max": [
        770.0,
        310.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -732.0,
      "bbox_min": [
        732.0,
        300.0,
        60.0
      ],
      "bbox_max": [
        732.0,
        310.0,
        64.00004577636719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        760.0,
        310.0,
        78.0
      ],
      "bbox_max": [
        770.0,
        334.9820556640625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        760.0,
        310.0,
        78.0
      ],
      "bbox_max": [
        760.0,
        334.0382995605469,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -602.2073974609375,
      "bbox_min": [
        -994.748046875,
        -1600.0,
        60.0
      ],
      "bbox_max": [
        650.0,
        1360.6285400390625,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 540.0,
      "bbox_min": [
        -994.748046875,
        -1600.0,
        60.0
      ],
      "bbox_max": [
        602.2073974609375,
        1324.3714599609375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        410.0213928222656,
        540.0,
        60.0
      ],
      "bbox_max": [
        602.2073974609375,
        1324.3714599609375,
        550.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        544.5025024414062,
        540.0,
        60.0
      ],
      "bbox_max": [
        602.2073974609375,
        755.2131958007812,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 926.1088256835938,
      "bbox_min": [
        544.5025024414062,
        579.0,
        78.0
      ],
      "bbox_max": [
        602.2073974609375,
        755.2131958007812,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6324553489685059,
        -0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": -45.806488037109375,
      "bbox_min": [
        595.8578491210938,
        579.0,
        78.0
      ],
      "bbox_max": [
        602.2073974609375,
        586.3495483398438,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 926.1088256835938,
      "bbox_min": [
        554.5025024414062,
        570.0,
        60.0
      ],
      "bbox_max": [
        602.2073974609375,
        755.2131958007812,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6324553489685059,
        -0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": -45.806488037109375,
      "bbox_min": [
        596.2720947265625,
        570.0,
        60.0
      ],
      "bbox_max": [
        602.2073974609375,
        584.935302734375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -550.0,
      "bbox_min": [
        410.0213928222656,
        580.0,
        80.0
      ],
      "bbox_max": [
        602.2073974609375,
        1324.3714599609375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        -0.3090174198150635,
        0.0
      ],
      "plane_d": 882.6156005859375,
      "bbox_min": [
        410.0213928222656,
        739.7156982421875,
        80.0
      ],
      "bbox_max": [
        550.0,
        1285.0,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 1301.7037353515625,
      "bbox_min": [
        530.4696044921875,
        1209.3953857421875,
        160.0
      ],
      "bbox_max": [
        550.0,
        1223.5849609375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        7.630560139659792e-05,
        -1.0,
        0.0
      ],
      "plane_d": 749.9580078125,
      "bbox_min": [
        410.0213928222656,
        739.7156982421875,
        80.0
      ],
      "bbox_max": [
        550.0,
        869.8349609375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071070671081543,
        -0.7071065902709961,
        0.0
      ],
      "plane_d": 176.77639770507812,
      "bbox_min": [
        499.9961853027344,
        749.9961547851562,
        240.0
      ],
      "bbox_max": [
        550.0,
        869.8349609375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0002752529107965529,
        -0.0
      ],
      "plane_d": -550.2064208984375,
      "bbox_min": [
        499.9961853027344,
        749.9961547851562,
        240.0
      ],
      "bbox_max": [
        549.9862060546875,
        869.8349609375,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6504541039466858,
        -0.759545624256134,
        0.0
      ],
      "plane_d": 302.9510498046875,
      "bbox_min": [
        499.9961853027344,
        749.9961547851562,
        360.0
      ],
      "bbox_max": [
        549.9862060546875,
        869.8349609375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48428842425346375,
        -0.4842880964279175,
        0.7286493182182312
      ],
      "plane_d": -177.67437744140625,
      "bbox_min": [
        499.9961853027344,
        749.9961547851562,
        410.0
      ],
      "bbox_max": [
        549.9862060546875,
        837.8707885742188,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.00027554581174626946,
        -0.0
      ],
      "plane_d": -550.2066650390625,
      "bbox_min": [
        549.9862060546875,
        750.0,
        240.0
      ],
      "bbox_max": [
        550.0,
        799.9862060546875,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24342486262321472,
        -0.24342486262321472,
        -0.9388762712478638
      ],
      "plane_d": 123.02920532226562,
      "bbox_min": [
        546.4309692382812,
        739.7156982421875,
        80.0
      ],
      "bbox_max": [
        550.0,
        746.853759765625,
        81.85070037841797
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        550.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        602.2073974609375,
        1324.3714599609375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 1301.7037353515625,
      "bbox_min": [
        550.0,
        750.0,
        80.0
      ],
      "bbox_max": [
        602.2073974609375,
        1324.3714599609375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5877826809883118,
        -0.8090188503265381,
        0.0
      ],
      "plane_d": 717.474365234375,
      "bbox_min": [
        581.5086059570312,
        1185.6285400390625,
        160.0
      ],
      "bbox_max": [
        602.2073974609375,
        1324.3714599609375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1185.6285400390625,
      "bbox_min": [
        582.7122802734375,
        1185.6285400390625,
        160.0
      ],
      "bbox_max": [
        602.2073974609375,
        1185.6285400390625,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.24342486262321472,
        -0.24342486262321472,
        -0.9388762712478638
      ],
      "plane_d": 123.02920532226562,
      "bbox_min": [
        553.146240234375,
        750.0,
        80.0
      ],
      "bbox_max": [
        559.7156982421875,
        753.2847290039062,
        81.70327758789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 91.92388916015625,
      "bbox_min": [
        550.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        602.2073974609375,
        750.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        550.0,
        705.0,
        80.0
      ],
      "bbox_max": [
        595.0,
        750.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24342486262321472,
        -0.24342486262321472,
        -0.9388762712478638
      ],
      "plane_d": 123.02920532226562,
      "bbox_min": [
        550.0,
        719.1421508789062,
        80.0
      ],
      "bbox_max": [
        595.0,
        750.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 111.92391967773438,
      "bbox_min": [
        560.8578491210938,
        719.1421508789062,
        90.0
      ],
      "bbox_max": [
        590.5001831054688,
        739.1421508789062,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 933.3810424804688,
      "bbox_min": [
        580.8578491210938,
        729.4998168945312,
        90.0
      ],
      "bbox_max": [
        590.5001831054688,
        739.1421508789062,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 926.1088256835938,
      "bbox_min": [
        559.7156982421875,
        725.0,
        80.0
      ],
      "bbox_max": [
        595.0,
        750.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 933.3810424804688,
      "bbox_min": [
        575.7156982421875,
        725.0,
        80.0
      ],
      "bbox_max": [
        595.0,
        739.1421508789062,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 111.92391967773438,
      "bbox_min": [
        575.7156982421875,
        734.0,
        80.0
      ],
      "bbox_max": [
        580.8578491210938,
        739.1421508789062,
        90.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        500.0,
        280.0,
        118.0
      ],
      "bbox_max": [
        505.0,
        318.8201904296875,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -994.748046875,
        -1600.0,
        60.0
      ],
      "bbox_max": [
        602.2073974609375,
        -1013.1572875976562,
        273.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18530525267124176,
        0.5702676773071289,
        0.8002853393554688
      ],
      "plane_d": 680.0791625976562,
      "bbox_min": [
        -994.748046875,
        -1600.0,
        60.0
      ],
      "bbox_max": [
        -439.7000732421875,
        -1421.7359619140625,
        273.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -668.6326904296875,
        -1600.0,
        60.0
      ],
      "bbox_max": [
        -439.7000732421875,
        -1421.7359619140625,
        273.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14309725165367126,
        0.2930086553096771,
        0.9453407526016235
      ],
      "plane_d": 323.03399658203125,
      "bbox_min": [
        -265.913330078125,
        -1590.916259765625,
        60.0
      ],
      "bbox_max": [
        602.2073974609375,
        -1013.1572875976562,
        242.550048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        553.7422485351562,
        -1314.81640625,
        60.0
      ],
      "bbox_max": [
        602.2073974609375,
        -1013.1572875976562,
        156.97283935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 540.0,
      "bbox_min": [
        602.2073974609375,
        -1600.0,
        60.0
      ],
      "bbox_max": [
        650.0,
        1324.3714599609375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        602.2073974609375,
        540.0,
        60.0
      ],
      "bbox_max": [
        650.0,
        1324.3714599609375,
        550.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        602.2073974609375,
        540.0,
        78.0
      ],
      "bbox_max": [
        650.0,
        586.1421508789062,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -65.15435791015625,
      "bbox_min": [
        638.0,
        545.8578491210938,
        78.0
      ],
      "bbox_max": [
        650.0,
        557.8578491210938,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        602.2073974609375,
        732.2073974609375,
        80.0
      ],
      "bbox_max": [
        650.0,
        1324.3714599609375,
        550.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 578.7291259765625,
      "bbox_min": [
        602.2073974609375,
        1185.6285400390625,
        160.0
      ],
      "bbox_max": [
        650.0,
        1324.3714599609375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1324.3714599609375,
      "bbox_min": [
        602.2073974609375,
        1185.6285400390625,
        160.0
      ],
      "bbox_max": [
        647.2877197265625,
        1324.3714599609375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1185.6285400390625,
      "bbox_min": [
        602.2073974609375,
        1185.6285400390625,
        160.0
      ],
      "bbox_max": [
        647.2877197265625,
        1225.0,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1225.0,
      "bbox_min": [
        602.2073974609375,
        1185.6285400390625,
        501.5
      ],
      "bbox_max": [
        647.2877197265625,
        1225.0,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 535.0,
      "bbox_min": [
        631.7926025390625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        647.2877197265625,
        1200.0,
        535.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6250033378601074,
        -0.7806220650672913
      ],
      "plane_d": -331.975830078125,
      "bbox_min": [
        635.7926025390625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        643.2877197265625,
        1190.0,
        527.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -635.7925415039062,
      "bbox_min": [
        635.7926025390625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        635.7926025390625,
        1190.0,
        527.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 91.92391967773438,
      "bbox_min": [
        602.2073974609375,
        732.2073974609375,
        80.0
      ],
      "bbox_max": [
        620.0,
        750.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -620.0,
      "bbox_min": [
        605.0,
        290.714111328125,
        60.0
      ],
      "bbox_max": [
        650.0,
        540.0,
        220.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 495.0,
      "bbox_min": [
        605.0,
        485.0,
        156.0
      ],
      "bbox_max": [
        620.0,
        495.0,
        166.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 166.0,
      "bbox_min": [
        605.0,
        485.0,
        166.0
      ],
      "bbox_max": [
        620.0,
        495.0,
        166.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        -0.0,
        0.44721361994743347
      ],
      "plane_d": -590.3219604492188,
      "bbox_min": [
        620.0,
        290.714111328125,
        60.0
      ],
      "bbox_max": [
        650.0,
        540.0,
        156.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        630.0,
        324.60308837890625,
        78.0
      ],
      "bbox_max": [
        650.0,
        540.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        630.0,
        324.60308837890625,
        78.0
      ],
      "bbox_max": [
        650.0,
        540.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 324.60308837890625,
      "bbox_min": [
        630.0,
        324.60308837890625,
        78.0
      ],
      "bbox_max": [
        650.0,
        324.60308837890625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        630.0,
        460.0,
        98.0
      ],
      "bbox_max": [
        650.0,
        480.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 460.0,
      "bbox_min": [
        630.0,
        460.0,
        98.0
      ],
      "bbox_max": [
        650.0,
        460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9796782732009888,
        -0.20057573914527893,
        0.0
      ],
      "plane_d": 719.490966796875,
      "bbox_min": [
        620.0,
        460.0,
        78.0
      ],
      "bbox_max": [
        630.0,
        540.0,
        156.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        623.85791015625,
        510.0,
        78.0
      ],
      "bbox_max": [
        630.0,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        623.85791015625,
        510.0,
        80.0
      ],
      "bbox_max": [
        630.0,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        620.0,
        460.0,
        98.0
      ],
      "bbox_max": [
        630.0,
        495.0,
        156.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 155.0,
      "bbox_min": [
        620.0,
        460.0,
        98.0
      ],
      "bbox_max": [
        630.0,
        495.0,
        156.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -625.0,
      "bbox_min": [
        625.0,
        485.0,
        155.0
      ],
      "bbox_max": [
        625.0,
        495.0,
        156.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 460.0,
      "bbox_min": [
        620.0,
        460.0,
        98.0
      ],
      "bbox_max": [
        630.0,
        460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        602.2073974609375,
        -1600.0,
        60.0
      ],
      "bbox_max": [
        650.0,
        291.6624755859375,
        253.5253448486328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        602.2073974609375,
        -1600.0,
        242.55006408691406
      ],
      "bbox_max": [
        650.0,
        -1590.916259765625,
        252.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09441325813531876,
        0.9955331087112427,
        0.0
      ],
      "plane_d": -220.8793182373047,
      "bbox_min": [
        602.2073974609375,
        -1600.0,
        60.0
      ],
      "bbox_max": [
        650.0,
        291.6624755859375,
        253.5253448486328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        602.2073974609375,
        -1600.0,
        246.88169860839844
      ],
      "bbox_max": [
        650.0,
        -1594.5013427734375,
        253.5253448486328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.672899067401886,
        0.7397342920303345,
        0.0
      ],
      "plane_d": -632.2486572265625,
      "bbox_min": [
        620.0,
        281.61761474609375,
        60.0
      ],
      "bbox_max": [
        630.0,
        291.6624755859375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        -0.0,
        0.44721361994743347
      ],
      "plane_d": -590.3219604492188,
      "bbox_min": [
        620.0,
        281.61761474609375,
        60.0
      ],
      "bbox_max": [
        630.0,
        291.6624755859375,
        80.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}